module.exports = __webpack_public_path__ + "img/haofangfang.b459f986.jpg";